/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeveloperApp } from './DeveloperApp';
import {
    DeveloperAppFromJSON,
    DeveloperAppFromJSONTyped,
    DeveloperAppToJSON,
} from './DeveloperApp';

/**
 * 
 * @export
 * @interface DeveloperAppResponse
 */
export interface DeveloperAppResponse {
    /**
     * 
     * @type {DeveloperApp}
     * @memberof DeveloperAppResponse
     */
    data?: DeveloperApp;
}

/**
 * Check if a given object implements the DeveloperAppResponse interface.
 */
export function instanceOfDeveloperAppResponse(value: object): value is DeveloperAppResponse {
    let isInstance = true;

    return isInstance;
}

export function DeveloperAppResponseFromJSON(json: any): DeveloperAppResponse {
    return DeveloperAppResponseFromJSONTyped(json, false);
}

export function DeveloperAppResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeveloperAppResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : DeveloperAppFromJSON(json['data']),
    };
}

export function DeveloperAppResponseToJSON(value?: DeveloperAppResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': DeveloperAppToJSON(value.data),
    };
}

